import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const DocuSignCallback = () => {
  const [searchParams] = useSearchParams();

  const authCode = searchParams.get("code");

  useEffect(() => {
    if (authCode) {
      // Best Practice: Use sessionStorage instead of localStorage
      // sessionStorage is cleared when tab closes, more secure for temporary secrets
      const codeVerifier = sessionStorage.getItem('docusign_code_verifier');
      
      if (!codeVerifier) {
        console.error("Missing code_verifier for PKCE");
        if (window.opener) {
          window.opener.postMessage("docusign-auth-error", "*");
        }
        return;
      }
      
      axios.post(
        "/hrapi/integrations/docusign/callback/",
        { 
          code: authCode,
          code_verifier: codeVerifier  // PKCE: include code_verifier
        },
        { withCredentials: true }
      )
        .then((response) => {
          // Best Practice: Clear code_verifier immediately after use (single-use)
          sessionStorage.removeItem('docusign_code_verifier');
          if (window.opener) {
            window.opener.postMessage("docusign-auth-success", "*");
            window.close();
          }
        })
        .catch((err) => {
          // Best Practice: Clear code_verifier on error too (prevent reuse)
          sessionStorage.removeItem('docusign_code_verifier');
          console.error("Error getting DocuSign token:", err);
          if (window.opener) {
            window.opener.postMessage("docusign-auth-error", "*");
          }
        });
    }
  }, [authCode]);

  return <h2>Authenticating with DocuSign...</h2>;
};

export default DocuSignCallback;

